import logo from "./logo.svg";
import { BrowserRouter, Routes, Route, redirect } from "react-router-dom";
import Home from "./pages/home/home";
import ThemeContext from "./context/ThemeContext";
import { useEffect, useState } from "react";
import "./App.css";
import themes from "./themes/themes.json";
import Redirect from "./components/redirect/redirect";
import ResumePage from "./pages/resume/resumePage";

function App() {
  const [initialLoad, setInitialLoad] = useState(true);
  const [theme, setTheme] = useState("light");

  //once per render
  useEffect(() => {
    if (localStorage.getItem("theme") == null) {
      localStorage.setItem("theme", theme);
    }

    if (initialLoad && localStorage.getItem("theme") != null) {
      setTheme(localStorage.getItem("theme"));
      setInitialLoad(false);
    }
    updateSiteTheme();
  }, [theme]);

  function updateSiteTheme() {
    var r = document.querySelector(":root");
    let colors = themes[theme];
    Object.keys(colors).forEach((key) => {
      // transform camelCase to kebab-case
      const cssKey = "--" + key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
      r.style.setProperty(cssKey, colors[key]);
    });
    //save theme in local storage
    if (!initialLoad) {
      localStorage.setItem("theme", theme);
    }
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route
            path="/linkedin"
            element={<Redirect href={"https://www.linkedin.com/in/sean-brill-590752142/"} />}
          />
          <Route path="/github" element={<Redirect href={"https://github.com/seanbrill"} />} />
        </Routes>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}

export default App;
